"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageEventHelpers = void 0;
var moment = require("moment");
var query_field_1 = require("../common/query-field");
var timeline_1 = require("../milestone/timeline");
var common_1 = require("../../schemas/common");
var utils_1 = require("../../utils");
var MessageEventHelpers = /** @class */ (function () {
    function MessageEventHelpers() {
    }
    /**
     * Builds message event instances
     */
    MessageEventHelpers.build = function (events, dogTd, eventProfile, metadata) {
        var _this = this;
        var date = metadata.date, breeds = metadata.breeds;
        // 1. Score each event by relevance
        // 2. Sort each event by relevance
        // 3. Build instances organized by date
        var messages = events
            .map(function (event) {
            return __assign(__assign(__assign({}, event), _this.startEnd(event, dogTd, eventProfile, { breeds: breeds })), { relevance: _this.relevance(event, dogTd, eventProfile, { date: date }) });
        })
            .sort(function (a, b) { return b.relevance - a.relevance; });
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
        }
        var map = {};
        var append = function (message, _date) {
            var _dateStr = _this.dateStr(_date.toDate());
            if (map.hasOwnProperty(_dateStr)) {
                _date.add(1, 'day');
                if (date.isBefore(message.end)) {
                    append(message, _date);
                }
                else {
                    console.log('Message could not fit, was not relevant enough::  ', message.id);
                }
            }
            else {
                map[_dateStr] = message;
            }
        };
        for (var _a = 0, messages_1 = messages; _a < messages_1.length; _a++) {
            var message = messages_1[_a];
            append(message, moment(message.start));
        }
        return map;
    };
    MessageEventHelpers.requirementQuery = function (event, dogTd, eventProfile, offsetDays) {
        if (offsetDays === void 0) { offsetDays = 14; }
        var allow = (event.timeline && event.timeline.min)
            ? moment()
                .subtract(dogTd.dog_days_old + offsetDays, 'days')
                .isAfter(event.timeline.min, event.timeline.unit)
            : true;
        for (var _i = 0, _a = event.requirements; _i < _a.length; _i++) {
            var requirement = _a[_i];
            try {
                if (!query_field_1.QueryField.run(dogTd, requirement)) {
                    allow = false;
                }
            }
            catch (e) {
                console.error('Failed to run requirement query', e.message, 'Requirement:', requirement);
                allow = false;
            }
        }
        return allow;
    };
    MessageEventHelpers.dateStr = function (date) {
        return timeline_1.TimelineNode.month(date.getMonth()) + "_" + date.getDate() + "_" + date.getFullYear();
    };
    MessageEventHelpers.startEnd = function (event, dogTd, eventProfile, metadata) {
        var start = moment();
        var end = start.clone();
        switch (event.type) {
            case 'ACTIVITY':
                // @TODO handle activity recurring
                if (event.timeframe) {
                    var activeMilestone = this.activeMilestone(eventProfile, event.$parent);
                    if (activeMilestone) {
                        start.set(moment(activeMilestone.start).toObject());
                        start.add(event.timeframe.start, event.timeframe.unit);
                        end.set(start.clone().add(event.timeframe.end, event.timeframe.unit).toObject());
                    }
                    else {
                        start.add(1, 'year');
                        end.add(2, 'year');
                    }
                }
                else {
                    throw new Error("Activity event \"" + event.id + "\" does not have a timeframe");
                }
                break;
            case 'ENVIRONMENT':
                end.add(1, 'months');
                break;
            case 'MILESTONE':
                // @TODO if active milestone set start date
                if (event.timeline) {
                    start.set(moment(dogTd.dog_dob).add(event.timeline.min, event.timeline.unit).toObject());
                    end.set(start.clone().add(event.timeline.max, event.timeline.unit).toObject());
                    if (event.timeline.breedSizeOffets) {
                        var size = utils_1.ProfileUtils.estimateBreedSize(utils_1.ProfileUtils.trainingDataToDog(dogTd), metadata.breeds);
                        if (event.timeline.breedSizeOffets.hasOwnProperty(size)) {
                            start.add(event.timeline.breedSizeOffets[size].value, event.timeline.breedSizeOffets[size].unit);
                            end.add(event.timeline.breedSizeOffets[size].value, event.timeline.breedSizeOffets[size].unit);
                        }
                    }
                    // provide 2 week notice
                    start.subtract(2, 'weeks');
                }
                else {
                    throw new Error("Milestone event \"" + event.id + "\" does not have a timeline");
                }
                break;
            case 'PLANNER':
                var planner = this.activePlanner(eventProfile, event.id);
                if (planner && planner.start) {
                    start.set(moment(planner.start).toObject());
                    if (planner.lastEvent) {
                        start.set(moment(planner.lastEvent).toObject());
                    }
                    // end.set(start.add((event as IPlannerMessageEvent).recurring.every, (event as IPlannerMessageEvent).recurring.unit).toObject())
                    end.add(7, 'days');
                }
                else {
                    end.add(7, 'days');
                }
                break;
            case 'SCIENCE':
                end.add(3, 'weeks');
                break;
            default:
                throw new Error("Cannot resolve event type \"" + event.type + "\"");
        }
        console.log(event.type, start.format(), end.format());
        return {
            start: start.toISOString(),
            end: end.toISOString()
        };
    };
    MessageEventHelpers.relevance = function (event, dogTd, eventProfile, metadata) {
        if (metadata === void 0) { metadata = { date: moment() }; }
        var allow = true;
        // @TODO adjust dogTd based on date
        event.requirements
            .filter(function (f) { return f.match === 'MUST'; })
            .forEach(function (f) {
            try {
                if (!query_field_1.QueryField.run(dogTd, f)) {
                    allow = false;
                }
            }
            catch (e) {
                console.error('Failed to run requirement query', e.message, 'Requirement:', f);
                allow = false;
            }
        });
        if (!allow) {
            return 0;
        }
        // Common rules
        // 1. Variety, if already asked similar type of event make it less relevant (
        // 2. If any "MUST" requirement return false, relevance must be 0
        // 3. The more "SHOULD" requirements return false, the more irrelevant the event should be
        // 4. Somehow user preferences are taken into account of the events
        // 5. Event severity
        var sum = 0;
        var count = 0;
        sum += this.severityScore(event.severity);
        count++;
        console.log('Severity Score', sum, count);
        var last = moment().diff(eventProfile.last.hasOwnProperty(event.type.toLowerCase()) ? moment(eventProfile.last[event.type.toLowerCase()]) : moment().subtract(7, 'days'), 'days', true) / 7;
        sum += last > 1 ? 1 : last;
        count++;
        console.log('Variety', sum, count);
        var shoulds = event.requirements
            .filter(function (f) { return f.match === 'SHOULD'; });
        if (shoulds.length > 0) {
            sum += shoulds.reduce(function (accumulator, f) {
                try {
                    if (query_field_1.QueryField.run(dogTd, f)) {
                        return accumulator + 1;
                    }
                }
                catch (e) {
                    console.error('Failed to run requirement query', e.message, 'Requirement:', f);
                }
                return accumulator;
            }, 0)
                / shoulds.length;
            count++;
            console.log('Shoulds', sum, count);
        }
        switch (event.type) {
            case 'ACTIVITY':
                // Activity rules
                // 1. If activity was already answered, make it less relevant (within 7 days)
                if (metadata.activityResponse) {
                }
                break;
            case 'MILESTONE':
                // Milestone rules
                // 1. If before two weeks of start date or pass end date, should be zero
                // 2. If asked already, don't ask again (within 7 days)
                // 3. If asked and rejected 3 times, don't ask again
                break;
            case 'ENVIRONMENT':
                // Environment rules
                break;
            case 'SCIENCE':
                // Science rules
                // 1. If not specific to the dog's personal attributes then make it less relevant
                // 2. If not specific to the dog's breed then make it less relevant
                break;
            case 'PLANNER':
                // Planner Events
                // 1. If asked and rejected 3 times, don't ask again
                // 2. Must be subscribed to planner event
                break;
            default:
                throw new Error("Unhandled event type \"" + event.type + "\"");
        }
        return sum / count;
    };
    MessageEventHelpers.severityScore = function (severity) {
        switch (severity) {
            case common_1.Severity.CRITICAL:
                return 1;
            case common_1.Severity.MAJOR:
                return 0.7;
            case common_1.Severity.MINOR:
                return 0.5;
            case common_1.Severity.OPTIONAL:
                return 0.3;
            default:
                return -1;
        }
    };
    MessageEventHelpers.activeMilestone = function (eventProfile, milestone) {
        var index = eventProfile.active.milestones.findIndex(function (m) { return m.id === milestone; });
        return index > -1 ? eventProfile.active.milestones[index] : null;
    };
    MessageEventHelpers.activePlanner = function (eventProfile, planner) {
        var index = eventProfile.active.planners.findIndex(function (p) { return p.id === planner; });
        return index > -1 ? eventProfile.active.planners[index] : null;
    };
    return MessageEventHelpers;
}());
exports.MessageEventHelpers = MessageEventHelpers;
